export default {
  /* -------------------------------------------------------------------------- */
  /*                             Category List State                            */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  DiamondRecords: [],
  total: 0,
  FilteredCount: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create Category State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit Category State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false,
}
